import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { HomeService } from '../../pages/home/home.service.mjs';


@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, CardModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})

export class FooterComponent implements OnInit {

  footerInfo: any = {
    "menu": [
        { label: 'Home', target: 'app-banner', command: () => this.scrollToSection('.app-banner') },
        { label: 'Plans & Pricing', target: 'app-plans-pricing', command: () => this.scrollToSection('.app-plans-pricing') },
        { label: 'Services', target: 'app-services', command: () => this.scrollToSection('.app-services') },
        { label: 'Installation Questions', target: 'app-installation-questions', command: () => this.scrollToSection('.app-installation-questions') },
        { label: 'About', target: 'app-about-us', command: () => this.scrollToSection('.app-about-us') },
        { label: 'FAQ', target: 'app-frequently', command: () => this.scrollToSection('.app-frequently') },
        { label: 'Contact', target: 'app-contact-info', command: () => this.scrollToSection('.app-contact-info') },
      ],
    "contact": {
        "phone": {
            "icon": "images/contact-icon-1.png",
            "text": "571.410.5811"
        },
        "email": {
            "icon": "images/contact-icon-2.png",
            "text": "info@claddedglass.com"
        },
        "address": {
            "icon": "images/contact-icon-3.png",
            "text": "North Fork, Purcellville, Virginia"
        }
    },
    "social": [
        {
            "id": 1,
            "icon": "fab fa-facebook-f",
            "link": "/"
        },
        {
            "id": 2,
            "icon": "fab fa-twitter",
            "link": "/"
        },
        {
            "id": 3,
            "icon": "fab fa-instagram",
            "link": "/"
        },
        {
            "id": 4,
            "icon": "fab fa-youtube",
            "link": "/"
        }
    ]
};

  constructor(private homeService: HomeService) {}

  ngOnInit() {
  }
  
  scrollToSection(target: string): void {
    console.debug("scroll to position", target);
      const element = document.querySelector(target);
      const offsetTop = window.innerWidth < 767 ? 68 : 100;
      if (element) {
        // Calculate the desired scroll position with some spacing
        const offset = offsetTop;  // The space you want from the top (you can adjust this value)
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const position = elementPosition - offset;  // Adjust position by offset
        
        // Scroll to the calculated position
        window.scrollTo({
          top: position,
          behavior: 'smooth'
        });
    }
  }  
}
